
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports/[region]",
      function () {
        return require("private-next-pages/airports/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports/[region]"])
      });
    }
  